import type { CSSProperties } from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDemo2Ctx } from '../Demo2Context';
import { TYPE_ICON_RI, type WorkStatus } from '../demo2Data';

type Filter = WorkStatus | 'all';
const CHIPS: { k: Filter; l: string }[] = [{ k: 'all', l: '전체' }, { k: 'waiting', l: '대기' }, { k: 'progress', l: '진행중' }, { k: 'done', l: '완료' }];

export default function Demo2MWorklist() {
    const navigate = useNavigate();
    const { workOrders } = useDemo2Ctx();
    const [filter, setFilter] = useState<Filter>('all');

    const mine = workOrders.filter(w => w.assignee === '박현장');
    const list = mine.filter(w => filter === 'all' || w.status === filter)
        .sort((a, b) => ({ urgent: 0, high: 1, normal: 2 }[a.priority] - { urgent: 0, high: 1, normal: 2 }[b.priority]));

    return (
        <>
            <div className="m-header"><div className="m-header-ttl">작업 목록</div></div>
            <div className="m-body">
                <div className="m-body-p">
                    <div style={{ display: 'flex', gap: 7, marginBottom: 14, overflowX: 'auto' }}>
                        {CHIPS.map(c => {
                            const cnt = c.k === 'all' ? mine.length : mine.filter(w => w.status === c.k).length;
                            return (
                                <div key={c.k} className={`chip${filter === c.k ? ' active' : ''}`} style={{ flexShrink: 0 }} onClick={() => setFilter(c.k)}>{c.l} {cnt}</div>
                            );
                        })}
                    </div>
                    {list.length === 0 && (
                        <div className="d2-empty">
                            <i className="ri-file-list-3-line" />
                            <div className="d2-empty-txt">해당 상태의 작업이 없습니다</div>
                        </div>
                    )}
                    {list.map(w => {
                        const statusLbl = w.status === 'waiting' ? '대기' : w.status === 'progress' ? '진행중' : '완료';
                        const statusCls = w.status === 'waiting' ? 'neutral' : w.status === 'progress' ? 'caution' : 'good';
                        return (
                            <div
                                key={w.id}
                                className="m-worklist-item"
                                style={{ '--wl-color': w.priority === 'urgent' ? 'var(--danger)' : w.priority === 'high' ? 'var(--warn)' : 'var(--primary)' } as CSSProperties}
                                onClick={() => navigate(`/demo2/mobile/work-process/${w.id}`)}
                            >
                                <div className="m-wl-top">
                                    <span className="m-wl-title"><span className="m-wl-title-ico"><i className={TYPE_ICON_RI[w.type]} /></span>{w.title}</span>
                                    <span className={`badge badge-${statusCls}`}>{statusLbl}</span>
                                </div>
                                <div className="m-wl-meta">
                                    <span><i className="ri-map-pin-line" /> {w.zoneName}</span><span><i className="ri-calendar-line" /> {w.due}</span>
                                    {w.priority === 'urgent' && <span style={{ color: 'var(--danger)', fontWeight: 800 }}><i className="ri-flashlight-line" /> 긴급</span>}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
}
